import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import OrderFormPage from '@/orderForm/OrderForm/OrderFormPage/OrderFormPage';

/**
 * ClientOrderFormPage - Refactored Wrapper
 * Delegates all logic to the modern OrderFormPage wizard.
 */
const ClientOrderFormPage = ({ 
  cancelNewOrder, 
  inspectionIcon, 
  newOrderType, 
  previousOrderId, 
  previousOrderFile,
  previousPropertyId,
  updateOrderItem 
}) => {
  const navigate = useNavigate();

  const handleSuccessfulCreation = (data) => {
    const me = JSON.parse(window.sessionStorage.getItem('me'));
    const showSuccessPage = !!me?.disabledByModality;
    
    if (showSuccessPage) {
      navigate('/orders/success');
    } else {
      navigate('/orders');
    }
  };

  return (
    <OrderFormPage
      newOrderType={newOrderType}
      inspectionIcon={inspectionIcon}
      cancelNewOrder={cancelNewOrder}
      previousOrderId={previousOrderId}
      previousOrderFile={previousOrderFile}
      previousPropertyId={previousPropertyId}
      updateOrderItem={updateOrderItem}
      successfulOrderCreation={handleSuccessfulCreation}
    />
  );
};

ClientOrderFormPage.propTypes = {
  cancelNewOrder: PropTypes.func.isRequired,
  inspectionIcon: PropTypes.object,
  newOrderType: PropTypes.string.isRequired,
  previousOrderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previousOrderFile: PropTypes.object,
  previousPropertyId: PropTypes.string,
  updateOrderItem: PropTypes.func,
};

ClientOrderFormPage.defaultProps = {
  inspectionIcon: null,
  previousOrderId: null,
  previousOrderFile: null,
  previousPropertyId: null,
  updateOrderItem: null,
};

export default ClientOrderFormPage;
